import ionicCoreGlobalScript from '/harness/sepp/sepp_ui/node_modules/@ionic/core/dist/collection/global/ionic-global.js';
import datalabsEsaUiGlobalScript from '/harness/sepp/sepp_ui/node_modules/@datalabs/esa_ui/dist/collection/index.js';
import appGlobalScript from '/harness/sepp/sepp_ui/src/global/app.ts';
export const globalScripts = () => {
  appGlobalScript();
  datalabsEsaUiGlobalScript();
  ionicCoreGlobalScript();
};
